import { Col, Container, Image, Row } from "react-bootstrap";
import styles from "./style.module.scss";
import { toWebp } from "../../../utils/common";
import Link from "next/link";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

const ServicesForIndustries = ({ data }) => {
	let pointsLength = data?.points?.length
	return (
		<section className={`${styles["services-for-industries"]} bg-one home-padding-new`}>
			<Container className={styles["container"]}>
				<Row className='justify-content-center'>
					<Col lg={12}>
						<div className={styles["industries-content"]}>
							<h2 className="text-black">{data.title}</h2>
						</div>

						{pointsLength && <Row className={styles["industries-card-main"]}>
							{data?.points?.map((point) => (
								<Col lg={3} md={4} sm={4} xs={6} key={point.id}>
									<div className={`${styles["industries-card"]} border-2 border-color bg-white`}>
										<Image
											src={toWebp(
												`${baseUrl}${point?.image?.data?.attributes?.url}`
											)}
											alt={point?.image?.data?.attributes?.name}
										/>
										<span className="text-black text-normal font-semibold">{point?.title}</span>
									</div>

								</Col>

							))}
						</Row>}

						<div className='justify-content-center d-flex'>
							{data?.cta?.id && (
								<Link className="btn btn-primary" href={data?.cta?.href}>
									{data?.cta?.label}
								</Link>
							)}
						</div>

					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default ServicesForIndustries;

